import { render, staticRenderFns } from "./portfolio-content-card.vue?vue&type=template&id=7b0bb2b8&scoped=true"
import script from "./portfolio-content-card.ts?vue&type=script&lang=ts&external"
export * from "./portfolio-content-card.ts?vue&type=script&lang=ts&external"
import style0 from "./portfolio-content-card.scss?vue&type=style&index=0&id=7b0bb2b8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b0bb2b8",
  null
  
)

export default component.exports